// ====================================================================================
// formHeaderSearch.module
// ====================================================================================

const headerSearch = document.querySelector(".header .form-header-search");
const searchInput = headerSearch.querySelector("input");

const changeFormClasses = (func) => {
  let formClasses = headerSearch.classList;

  if (func === "add") {
    formClasses.add("active");
    return;
  }

  if (func === "remove") {
    formClasses.remove("active");
    return;
  }

  if (formClasses.contains("active")) {
    formClasses.remove("active");
  } else {
    formClasses.add("active");
  }
};

export const init = () => {
  let attempts = 0;
  let prevScreenWidth = window.innerWidth;

  // if document.ready needed
  const whenComplete = () => {
    if (attempts > 30) return;
    attempts += 1;
    if (document.readyState === "complete") {
      // Search handler for mobile screens
      // Search field with submit button are fading up when user clicks on a round search button
      headerSearch
        .querySelector('[data-js="header-search"]')
        .addEventListener("click", function (e) {
          if (prevScreenWidth > 767) return;
          e.preventDefault();
          changeFormClasses();
        });

      // Search focusin handler (tablets and desktops)
      // Search field becomes wider on focus event and search button is within search box
      searchInput.addEventListener("focusin", function (e) {
        if (prevScreenWidth < 768) return;
        e.preventDefault();
        changeFormClasses("add");
      });

      // Mobile search focusout handler (tablets and desktops)
      searchInput.addEventListener("focusout", function (e) {
        if (prevScreenWidth < 768) return;
        e.preventDefault();
        changeFormClasses("remove");
      });

      window.addEventListener("resize", function (e) {
        if (!e.isTrigger) {
          clearTimeout(this._timer);
          this._timer = setTimeout(() => {
            // google chrome bug fix
            if (Math.abs(window.innerWidth - prevScreenWidth) < 99) return;
            prevScreenWidth = window.innerWidth;
          }, 400);
        }
      });
    } else {
      setTimeout(function () {
        whenComplete();
      }, 400);
    }
  };
  whenComplete();
};
